import React, {useState} from 'react';
import {ChevronRight} from '../components/icons';

const POSITIVE = new Set(['Good', 'Yes', 'Pass']);
const NEGATIVE = new Set(['No', 'Poor', 'Auto Fail', 'Fail']);

function toneFor(answer: string): 'positive' | 'negative' | 'neutral' {
  if (POSITIVE.has(answer)) return 'positive';
  if (NEGATIVE.has(answer)) return 'negative';
  return 'neutral';
}

const RoadTestToggle: React.FC<{element: any}> = ({element}) => {
  const [open, setOpen] = useState(true);
  const value = element.value;
  const valueTone = value ? toneFor(value) : 'none';

  return (
    <div className="roadtest-question">
      <button
        type="button"
        className="roadtest-question__header"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span className="roadtest-question__name">{element.name}</span>
        <span className={`roadtest-question__value roadtest-question__value--${valueTone}`}>
          {value || '—'}
        </span>
        <span className={`roadtest-question__chevron${open ? ' is-open' : ''}`} aria-hidden="true">
          <ChevronRight />
        </span>
      </button>

      {open ? (
        <div
          className="roadtest-question__options"
          style={{gridTemplateColumns: `repeat(${element.answers.length}, minmax(0, 1fr))`}}
        >
          {element.answers.map((answer: string, index: number) => {
            const selected = element.value === answer;
            const tone = toneFor(answer);
            return (
              <button
                type="button"
                key={index}
                className={`roadtest-question__option roadtest-question__option--${tone}${selected ? ' is-selected' : ''}`}
                onClick={() => element.func(answer)}
              >
                {answer}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default RoadTestToggle;
